import { Box, Chip, Grid, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface SectionBoxProps {
    children: ReactNode
    spacing?: number
}

/** Envuelve un grupo de inputs de formulario con el mismo estilo visual que FieldView */
export const SectionBox = ({ children, spacing = 2.5 }: SectionBoxProps) => (
    <Box
        sx={{
            p: 2.5,
            borderRadius: '10px',
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'action.hover',
        }}
    >
        <Grid container spacing={spacing}>
            {children}
        </Grid>
    </Box>
)

interface FieldViewProps {
    label: string
    value?: string | number | null
    children?: ReactNode
}

export const FieldView = ({ label, value, children }: FieldViewProps) => (
    <Box
        sx={{
            px: 2,
            py: 1.25,
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'action.hover',
            minHeight: '58px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
        }}
    >
        <Typography
            variant='caption'
            sx={{
                color: 'text.disabled',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.07em',
                fontSize: '0.65rem',
                lineHeight: 1,
                mb: 0.75,
                display: 'block',
            }}
        >
            {label}
        </Typography>
        {children ?? (
            <Typography variant='body2' sx={{ fontWeight: 500, color: 'text.primary', lineHeight: 1.4, wordBreak: 'break-word', }}>
                {value ?? '-'}
            </Typography>
        )}
    </Box>
)

export const SiNoChip = ({ value }: { value: any }) => {
    if (value === null || value === undefined) {
        return (
            <Typography variant='body2' sx={{ fontWeight: 500, color: 'text.secondary' }}>
                -
            </Typography>
        )
    }
    return (
        <Chip
            label={value ? 'Sí' : 'No'}
            size='small'
            color={value ? 'success' : 'default'}
            variant='outlined'
            sx={{ fontWeight: 700, fontSize: '0.75rem', height: '22px' }}
        />
    )
}
